import { useStateCurrentLocation } from '@ferreri/prever-component-lib';

export const useBusinessUnitStoredId = () => {
  const currentLocation = useStateCurrentLocation();
  const id = currentLocation?.id?.toString();

  return id;
};
